/**
 * Money formatting helpers.
 * Always produce US-locale strings with thousands separators, e.g. $1,234.56.
 */

const usd2 = new Intl.NumberFormat('en-US', {
	minimumFractionDigits: 2,
	maximumFractionDigits: 2
});

const usd0 = new Intl.NumberFormat('en-US', {
	minimumFractionDigits: 0,
	maximumFractionDigits: 0
});

/** Format a dollar amount as "$1,234.56". Accepts null/undefined/NaN safely. */
export function formatUsd(dollars: number | null | undefined): string {
	const n = Number(dollars);
	if (!Number.isFinite(n)) return '$0.00';
	return `$${usd2.format(n)}`;
}

/** Format a cent amount as "$1,234.56". Accepts null/undefined/NaN safely. */
export function formatUsdCents(cents: number | null | undefined): string {
	const n = Number(cents);
	if (!Number.isFinite(n)) return '$0.00';
	return `$${usd2.format(n / 100)}`;
}

/** Whole-dollar format, "$1,234". */
export function formatUsdWhole(dollars: number | null | undefined): string {
	const n = Number(dollars);
	if (!Number.isFinite(n)) return '$0';
	return `$${usd0.format(Math.round(n))}`;
}
